export default __webpack_public_path__ + "static/media/measurmenttest.295cf90a.jpg";